import React from 'react';
import Bold from '../../Bold';
import { Title } from 'bloomer/lib/elements/Title';

export default function AveragesPreamble({
	startDate,
	endDate,
	averageSingleEnrichment,
	averageDailyEnrichment,
	longStay,
	behaviour,
	animalType
}) {
	return (
		<div>
			{behaviour ? <Title tag="h4">Behaviour {animalType}s:</Title> : null}
			{longStay ? <Title tag="h4">Long Stay:</Title> : null}
			{!longStay && !behaviour ? <Title tag="h4">General:</Title> : null}
			<p>
				Between <Bold>{startDate}</Bold> and{' '}
				<Bold>{endDate}</Bold> the average length of a single
				enrichment session{' '}
				{longStay && !behaviour ? `for our longstay ${animalType}s` : null }
				{behaviour && !longStay ? `for our behaviour ${animalType}s` : null}{' '}
				was{' '}
				<Bold className="is-capitalized">
					{averageSingleEnrichment && averageSingleEnrichment.toFixed(2)} Minutes
				</Bold>.{' '}
				<span>
					The average total enrichment time for each {animalType} was{' '}
					<Bold className="is-capitalized">
						{averageDailyEnrichment && averageDailyEnrichment.toFixed(2)} Minutes
					</Bold>{' '}
					per day.
				</span>
			</p>
		</div>
	);
}
